import { useGetCurrentUserQuery } from '../api';
import { userTransformer } from '../helpers';

export function useCurrentUser() {
  const { data: user } = useGetCurrentUserQuery();
  return userTransformer(user);
}
